@if (offer(); as currentOffer) {
<div class="odp">
  <div class="odp__topbar">
    <button class="odp__back" type="button" (click)="close()">
      <span class="odp__back-arrow">&#8249;</span> Regresar
    </button>
  </div>
  <div class="odp__content">
    <app-offer-detail-view [data]="currentOffer" (backPressed)="close()" (applyPressed)="apply()" />
  </div>
</div>
}
